// extracted by mini-css-extract-plugin
export default {"cardHeaderWrapper":"AccountantCard_cardHeaderWrapper__ol-1Y","recordsWrapper":"AccountantCard_recordsWrapper__fG2dl"};